import request, { formatRequest } from "@/utils/request"
import RequestCancel from "@/utils/request-cancel"

import { IReturnItem } from "../management/type"
import {
  IAnalyticsProductReasonList,
  IAnalyticsProductReasonListData,
  IAnalyticsReasonList,
  IAnalyticsReasonListData,
  IAnalyticsReasonProductList,
  IAnalyticsReasonProductListData,
  IAnalyticsReturnProductListData,
  IDashboardStatistics,
  IReportAppEmbedParam,
  IReturnStatistics,
  IReturnStatisticsParam,
} from "./type"

export enum CloseBoxEnum {
  // 1 关闭B端好评弹窗 2 关闭notification页面的移除brand的弹窗
  bannerModal = 1,
  notificationBanner = 2,
}

export enum FollowEnum {
  follow = "follow",
  unFollow = "unfollow",
}

/** 上报小部件状态类型 */
export enum ReportAppEmbedKind {
  /** Request Return button */
  returnButton = 1,
  /** Returns standalone widget */
  standaloneWidget = 2,
}

const APIDashboard = {
  /**
   * 规则和弹窗的统计
   * @param params
   */
  getStatistics(params?: IReturnStatisticsParam) {
    return formatRequest(
      request.post<IReturnStatistics>("/go-api/v1/com/index", params),
      {
        error: {
          duration: 10 * 1000,
        },
      },
    )
  },
  /**
   * 获取首页面板统计信息 最近N天 v2
   * @param params
   */
  getDashboardStatistics(params?: IReturnStatisticsParam) {
    return formatRequest(
      request.post<IDashboardStatistics>(
        "/go-api/v1/analytics/v2/index",
        params,
      ),
      {
        error: {
          duration: 10 * 1000,
        },
      },
    )
  },

  /**
   * 获取运营分析.操作数据（核心统计 + Top N）
   * @param params
   */
  getAnalyticsOperation(params?: IReturnStatisticsParam) {
    return formatRequest(
      request.post<IDashboardStatistics>(
        "/go-api/v1/analytics/operation",
        params,
      ),
      {
        error: {
          duration: 10 * 1000,
        },
      },
    )
  },

  /**
   * 退货理由占比列表
   * @param params
   */
  getAnalyticsReasonList(params?: IAnalyticsReasonList) {
    return formatRequest(
      request.post<IAnalyticsReasonListData>(
        "/go-api/v1/analytics/reason_list",
        params,
      ),
      {
        error: {
          duration: 10 * 1000,
        },
      },
    )
  },

  /**
   * 导出退货理由占比列表CSV表格
   * @param {IManagementConfig} params 入参
   */
  exportAnalyticsReasonList(params?: Partial<IAnalyticsReasonList>) {
    const url: string = "/go-api/v1/analytics/reason_list"

    RequestCancel.pop(url)

    return request.post<IReturnItem>(url, params, {
      cancelToken: RequestCancel.push(url),
      responseType: "blob",
    })
  },

  /**
   * 指定退货理由商品列表
   * @param params
   */
  getAnalyticsReasonProductList(params?: IAnalyticsReasonProductList) {
    return formatRequest(
      request.post<IAnalyticsReasonProductListData>(
        "/go-api/v1/analytics/reason_product_list",
        params,
      ),
      {
        error: {
          duration: 10 * 1000,
        },
      },
    )
  },

  /**
   * 导出指定退货理由商品列表CSV表格
   * @param {IManagementConfig} params 入参
   */
  exportAnalyticsReasonProductList(
    params?: Partial<IAnalyticsReasonProductList>,
  ) {
    const url: string = "/go-api/v1/analytics/reason_product_list"

    RequestCancel.pop(url)

    return request.post<IReturnItem>(url, params, {
      cancelToken: RequestCancel.push(url),
      responseType: "blob",
    })
  },

  /**
   * 退货商品聚合列表
   * @param params
   */
  getAnalyticsReturnProductList(params?: IAnalyticsReasonList) {
    return formatRequest(
      request.post<IAnalyticsReturnProductListData>(
        "/go-api/v1/analytics/return_product_list",
        params,
      ),
      {
        error: {
          duration: 10 * 1000,
        },
      },
    )
  },

  /**
   * 导出退货商品聚合列表CSV表格
   * @param {IManagementConfig} params 入参
   */
  exportAnalyticsReturnProductList(params?: Partial<IAnalyticsReasonList>) {
    const url: string = "/go-api/v1/analytics/return_product_list"

    RequestCancel.pop(url)

    return request.post<IReturnItem>(url, params, {
      cancelToken: RequestCancel.push(url),
      responseType: "blob",
    })
  },

  /**
   * 指定退货变体退货理由列表
   * @param params
   */
  getAnalyticsProductReasonList(params?: IAnalyticsProductReasonList) {
    return formatRequest(
      request.post<IAnalyticsProductReasonListData>(
        "/go-api/v1/analytics/product_reason_list",
        params,
      ),
      {
        error: {
          duration: 10 * 1000,
        },
      },
    )
  },

  /**
   * 指定退货变体退货理由列表CSV表格
   * @param {IManagementConfig} params 入参
   */
  exportAnalyticsProductReasonList(
    params?: Partial<IAnalyticsProductReasonList>,
  ) {
    const url: string = "/go-api/v1/analytics/product_reason_list"

    RequestCancel.pop(url)

    return request.post<IReturnItem>(url, params, {
      cancelToken: RequestCancel.push(url),
      responseType: "blob",
    })
  },

  /**
   * 获取运营分析.概览数据
   * @param params
   */
  getAnalyticsOverview(params?: IReturnStatisticsParam) {
    return formatRequest(
      request.post<IDashboardStatistics>(
        "/go-api/v1/analytics/overview_v2",
        params,
      ),
      {
        error: {
          duration: 10 * 1000,
        },
      },
    )
  },

  // 关闭好评引导
  closePraiseGuide() {
    return request.get("/v1/closePraiseGuide")
  },

  /**
   * 发送反馈
   * @param email
   * @param content
   */
  sendFeedback(email: string, content: string) {
    return request.post("/v1/feedback", {
      content,
      contact_email: email,
    })
  },

  closeBanner(show: boolean) {
    return request.put("/v1/banners/guide", {
      show: show,
    })
  },
  closeBox(params: { type: CloseBoxEnum }) {
    return formatRequest(request.get("/v1/closeBox", { params }))
  },
  followPro(action: FollowEnum) {
    return request.get("/v1/followProduct", { params: { action: action } })
  },

  /**
   * 保存首页面板引导信息
   * @param
   * return_page_accessed\return_setting_accessed\enable_default_carrier\setup_free_return_service
   */
  saveGuide(type: string, val: boolean) {
    return request.post("/go-api/v1/com/index/guide", {
      [type]: val,
    })
  },

  /**
   * 上报小部件状态
   * @param params kind=1 → Request Return button；kind=2 → Returns standalone widget
   */
  reportAppEmbed(params: IReportAppEmbedParam) {
    return request.post("/go-api/v1/analytics/report_app_embed", params)
  },
}

export default APIDashboard
